export default __webpack_public_path__ + "static/media/Icon_Odering.074b84a6.svg";